import { Alerts } from 'constants/alerts';
import { Resources } from 'constants/resources';

import { useApiContext } from 'context/apiContext';
import { usePermissions } from 'hooks/usePermissions';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Alert } from 'shared/mui/Alert/Alert';
import { CreateButton } from 'shared/mui/Buttons';
import { Divider } from 'shared/mui/Divider/Divider';
import { ListPage } from 'shared/react-admin/Pages';
import { Permission } from 'types/embedded/permission';

import { GatewayRulesDatagrid, GatewayRulesViewToggle } from './components';
import { GatewayRulesFilters } from './GatewayRulesFilters/GatewayRulesFilters';
import { useResetExpandedGatewayRules } from './hooks/useResetExpandedGatewayRules';

export const GatewayRulesList: React.FC = () => {
  const translate = useTypedTranslate();

  const { user } = useApiContext();
  const { hasResourcePermissions } = usePermissions();
  const { resetExpandedRules } = useResetExpandedGatewayRules();

  return (
    <ListPage
      actions={[
        hasResourcePermissions(Resources.GatewayRules, [Permission.Full, Permission.Create]) && (
          <CreateButton key="create-rules" />
        ),
        <Divider flexItem key="divider" orientation="vertical" sx={{ marginX: 2 }} />,
        <GatewayRulesViewToggle key="gateway_rules_view_toggle" />,
      ]}
      empty={false}
      headerTitle={{ titleText: translate('app.gatewayRules.titleText') }}
      sort={{ field: 'id', order: 'DESC' }}
    >
      <GatewayRulesFilters />
      {user.alerts.includes(Alerts.EmptyMerchantAccess) ? (
        <Alert severity="warning">
          {translate('app.gatewayRules.noRulesAlert', {
            firstName: user.firstName,
            lastName: user.lastName,
          })}
        </Alert>
      ) : (
        <GatewayRulesDatagrid resetExpandedRules={resetExpandedRules} />
      )}
    </ListPage>
  );
};
